var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconActionConversation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.931 18.4274L20.2885 21.3241C20.3802 22.0849 19.5644 22.6166 18.9135 22.2224L15.0727 19.9399C14.651 19.9399 14.2385 19.9124 13.8352 19.8574C14.5135 19.0599 14.9169 18.0516 14.9169 16.9607C14.9169 14.3574 12.6619 12.2491 9.87519 12.2491C8.81185 12.2491 7.83102 12.5516 7.01519 13.0833C6.98769 12.8541 6.97852 12.6249 6.97852 12.3866C6.97852 8.21574 10.5994 4.83325 15.0727 4.83325C19.546 4.83325 23.1669 8.21574 23.1669 12.3866C23.1669 14.8616 21.8927 17.0524 19.931 18.4274Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9163 16.9609C14.9163 18.0517 14.513 19.0601 13.8347 19.8576C12.9272 20.9576 11.488 21.6634 9.87467 21.6634L7.48217 23.0842C7.07884 23.3317 6.56551 22.9926 6.62051 22.5251L6.84967 20.7193C5.62134 19.8668 4.83301 18.5009 4.83301 16.9609C4.83301 15.3476 5.69468 13.9267 7.01468 13.0834C7.83051 12.5517 8.81134 12.2493 9.87467 12.2493C12.6613 12.2493 14.9163 14.3576 14.9163 16.9609Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconActionConversation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-action-conversation.21dd6490250b04556800c5449aeabc25.svg";